/* eslint-disable no-underscore-dangle */
/* Kaveh's code from wrp-dss */
import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import L from 'leaflet'
import { Button } from 'semantic-ui-react';
import { isDrawing } from 'modules/site'

class Draw extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            activeAction: ''
        }

        this.handlePolygonClick = this.handlePolygonClick.bind(this)
        this.handlePointClick = this.handlePointClick.bind(this)
        this.handleEditClick = this.handleEditClick.bind(this)
        this.handleDeleteClick = this.handleDeleteClick.bind(this)
        this.handleSaveClick = this.handleSaveClick.bind(this)
        this.handleCancelClick = this.handleCancelClick.bind(this)
    }

    componentDidUpdate(prevProps) {
        if (prevProps.isModifying !== this.props.isModifying && this.props.isModifying === false) {
            let activeAction = this.state.activeAction
            if (activeAction === 'drawing') {
                this.props.map.drawControl._toolbars.draw._modes.polygon.handler.disable()
            }
            else if (activeAction === 'pointing') {
                this.props.map.drawControl._toolbars.draw._modes.marker.handler.disable()
            }
            this.setState({ activeAction: '' })
        }
    }

    handlePolygonClick() {
        this.props.map.drawControl._toolbars.draw._modes.polygon.handler.enable()
        this.setState({ activeAction: 'drawing' })
        this.props.isDrawing(true)
    }

    handlePointClick() {
        this.props.map.drawControl._toolbars.draw._modes.marker.handler.enable()
        this.setState({activeAction: 'pointing'})
        this.props.isDrawing(true)
    }

    handleEditClick() {
        this.props.map.drawControl._toolbars.edit._modes.edit.handler.enable()
        this.setState({ activeAction: 'editing' })
        this.props.isDrawing(true)
    }

    handleDeleteClick() {
        this.props.map.drawControl._toolbars.edit._modes.remove.handler.enable()
        this.setState({ activeAction: 'deleting' })
        this.props.isDrawing(true)
    }

    handleSaveClick() {
        const {activeAction} = this.state
        const {_modes: modes} = this.props.map.drawControl._toolbars.edit
        if (activeAction === 'editing') {
            modes.edit.handler.save()
            modes.edit.handler.disable()
        }
        else if (activeAction === 'deleting') {
            modes.remove.handler.save()
            modes.remove.handler.disable()
        }
        this.setState({ activeAction: '' })
        this.props.isDrawing(false)
    }

    handleCancelClick() {
        const {activeAction} = this.state
        const {_modes: modes} = this.props.map.drawControl._toolbars.edit
        if (activeAction === 'editing') {
            modes.edit.handler.revertLayers()
            modes.edit.handler.disable()
        }
        else if (activeAction === 'deleting') {
            modes.remove.handler.revertLayers()
            modes.remove.handler.disable()
        }
        else if (activeAction === 'drawing') {
            this.props.map.drawControl._toolbars.draw._modes.polygon.handler.disable()
            this.setState({activeAction: ''})
        }
        else if (activeAction === 'pointing') {
            this.props.map.drawControl._toolbars.draw._modes.marker.handler.disable()
            this.setState({activeAction: ''})
        }
        this.setState({ activeAction: '' })
        this.props.isDrawing(false)
    }

    render() {
        const {activeAction} = this.state
        return (
            <div className="field is-grouped">
                { activeAction === '' || activeAction === 'drawing' ?
                    <Button.Group>
                        <Button
                            type="button"
                            basic={activeAction !== 'drawing'}
                            size="small"
                            color="grey"
                            title="Draw Polygon"
                            alt="Draw Polygon"
                            onClick={this.handlePolygonClick}
                            disabled={activeAction === 'editing' || activeAction === 'deleting' || activeAction === 'pointing'}
                            icon="object ungroup"
                        />
                        {this.state.activeAction === 'drawing' ?
                            <Button
                                type="button"
                                basic
                                size="small"
                                color="grey"
                                title="Cancel"
                                alt="Cancel"
                                onClick={this.handleCancelClick}
                            >
                                Cancel
                            </Button>
                            : null
                        }
                    </Button.Group>
                    : null
                }
                &nbsp;
                { activeAction === '' || activeAction === 'pointing' ?
                    <Button.Group>
                        <Button
                            type="button"
                            basic={activeAction !== 'pointing'}
                            size="small"
                            color="grey"
                            title="Draw Point"
                            alt="Draw Point"
                            icon="point"
                            onClick={this.handlePointClick}
                            disabled={activeAction === 'editing' || activeAction === 'deleting' || activeAction === 'drawing'}
                        />
                        {this.state.activeAction === 'pointing' ?
                            <Button
                                type="button"
                                basic
                                size="small"
                                color="grey"
                                title="Cancel"
                                alt="Cancel"
                                onClick={this.handleCancelClick}
                            >
                                Cancel
                            </Button>
                            : null
                        }
                    </Button.Group>
                    : null
                }
                &nbsp;
                { this.props.layers.size > 0 && (activeAction === '' || activeAction === 'deleting') ?
                    <Button.Group>
                        <Button
                            type="button"
                            basic={activeAction !== 'deleting'}
                            size="small"
                            color="grey"
                            className="button is-danger"
                            disabled={activeAction === 'drawing' || activeAction === 'pointing' || activeAction === 'editing'}
                            title="Delete Drawing"
                            alt="Delete Drawing"
                            onClick={this.handleDeleteClick}
                            icon="trash"
                        />
                        {this.state.activeAction === 'deleting' ?
                                <Button
                                    type="button"
                                    basic
                                    size="small"
                                    color="grey"
                                    title="Confirm Deletions"
                                    alt="Done"
                                    onClick={this.handleSaveClick}
                                >
                                    Done
                                </Button>
                            : null
                        }
                        {this.state.activeAction === 'deleting' ?
                            <Button
                                type="button"
                                basic
                                size="small"
                                color="grey"
                                title="Discard Deletions"
                                alt="Cancel"
                                onClick={this.handleCancelClick}
                            >
                                Cancel
                            </Button>
                            : null
                        }
                    </Button.Group>
                    : null
                }
                &nbsp;
                {this.state.activeAction === 'deleting' ?
                    <ul>
                        <br />
                        <li>Click points / polygons to remove</li>
                        <li>Must click Done and SAVE (below) for changes to be stored</li>
                    </ul>
                    : null
                }
                {this.props.layers.size > 0 && (activeAction === '' || activeAction === 'editing') ?
                    <Button.Group>
                        <Button
                            type="button"
                            basic={activeAction !== 'editing'}
                            size="small"
                            color="grey"
                            title="Edit drawing"
                            onClick={this.handleEditClick}
                            disabled={activeAction === 'drawing' || activeAction === 'pointing' || activeAction === 'deleting'}
                            icon="edit"
                        />
                        {this.state.activeAction === 'editing' ?
                            <Button
                                type="button"
                                basic
                                size="small"
                                color="grey"
                                title="Confirm Edits"
                                alt="Done"
                                onClick={this.handleSaveClick}
                            >
                                Done
                            </Button>
                            : null
                        }
                        {this.state.activeAction === 'editing' ?
                            <Button
                                type="button"
                                basic
                                size="small"
                                color="grey"
                                title="Discard Edits"
                                alt="Cancel"
                                onClick={this.handleCancelClick}
                            >
                                Cancel
                            </Button>
                            : null
                        }
                    </Button.Group>
                    : null
                }
                {this.state.activeAction === 'editing' ?
                    <ul>
                        <br />
                        <li>Drag point / vertex / midpoint to move</li>
                        <li>Click vertex to delete</li>
                        <li>Must click Done and SAVE (below) for changes to be stored</li>
                    </ul>
                    : null
                }
            </div>
        )
    }
}

Draw.propTypes = {
    geometries: PropTypes.arrayOf(PropTypes.object),
    map: PropTypes.instanceOf(L.Map).isRequired,
    isModifying: PropTypes.bool,
    // actions
    isDrawing: PropTypes.func.isRequired
}

Draw.defaultProps = {
    geometries: [],
    isModifying: false
}

const mapStateToProps = state => ({
    isModifying: state.getIn(['site', 'isEditing']),
    layers: state.getIn(['surveys', 'layers'])
})

export default connect(mapStateToProps, { isDrawing })(Draw);



// WEBPACK FOOTER //
// ./source/containers/Surveys/Sidebar/Draw.jsx